import { FC } from 'react';
import Form from '../../../../components/common/Forms/Form';
import { ApplicantInformationFields, normalizeInitialValues } from '../../../../config/tuitionMangerViewDetailsFields';

interface ApplicantInformationProps {
  applicationData?: any;
}

const ApplicantInformation: FC<ApplicantInformationProps> = ({ applicationData }) => {
  return (
    <div>
      <h2 className="h3">Applicant information</h2>
      <Form
        fields={ApplicantInformationFields}
        initialValues={normalizeInitialValues(applicationData, ApplicantInformationFields)}
        isViewDetails
        buttons={[]}
        className="mt-4"
      />
    </div>
  );
};

export default ApplicantInformation;
